import(/* webpackMode: "eager", webpackExports: ["VoiceoverProvider"] */ "/home/circleci/project/apps/sb-shell/app/(darkHeader)/voiceover/_context/VoiceoverContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VoiceoverTabProvider"] */ "/home/circleci/project/apps/sb-shell/app/(darkHeader)/voiceover/_context/VoiceoverTabContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MAX_EDITABLE_CHANNELS"] */ "/home/circleci/project/apps/sb-shell/app/new/member/profile/youtubeChannelsForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/home/circleci/project/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/home/circleci/project/packages/design-system/dist/index.es10.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toast","ToastProvider"] */ "/home/circleci/project/packages/design-system/dist/index.es13.js");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/home/circleci/project/packages/design-system/dist/index.es14.js");
;
import(/* webpackMode: "eager", webpackExports: ["RadioGroup"] */ "/home/circleci/project/packages/design-system/dist/index.es15.js");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogClose","DialogContent","DialogDescription","DialogFooter","DialogHeader","DialogOverlay","DialogPortal","DialogTitle","DialogTrigger"] */ "/home/circleci/project/packages/design-system/dist/index.es16.js");
;
import(/* webpackMode: "eager", webpackExports: ["TabsContent","TabsList","TabsRoot","TabsTrigger"] */ "/home/circleci/project/packages/design-system/dist/index.es18.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/home/circleci/project/packages/design-system/dist/index.es2.js");
;
import(/* webpackMode: "eager", webpackExports: ["RichText"] */ "/home/circleci/project/packages/design-system/dist/index.es5.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/circleci/project/packages/design-system/dist/index.es6.js");
;
import(/* webpackMode: "eager", webpackExports: ["CollapsibleContent","CollapsibleRoot","CollapsibleTrigger"] */ "/home/circleci/project/packages/design-system/dist/index.es8.js");
